// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "site" + "-" + "e223ca7220eb3b8ceb61" + ".css";
};